<template>
  <div class="step3">
    <small-loading v-if="loading" />
    <separate :style="{ height: '2px' }" />
    <detail-line :list="info()" />
    <separate :style="{ height: '10px' }" />
    <detail-line :list="detail()" />
    <separate :style="{ height: '10px' }" />
    <van-steps
      direction="vertical"
      :active="active"
      :active-icon="icon"
      active-color="rgba(255, 0, 0, 1)"
      :class="{ 'van-hairline': false }"
    >
      <van-step v-for="(item, i) in statusListFn()" :key="i">
        <p class="name">{{ item.name }}</p>
        <p class="time">{{ item.value }}</p>
      </van-step>
    </van-steps>
    <div v-if="active === 0" class="info">
      <p>
        {{
          lang(
            '正在审核中，预计1～2个工作日内到账，请您耐心等待。您可在申请记录中查看。'
          )
        }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Separate from '@/components/separate.vue'
import DetailLine from '@/views/score/component/orderDetail/detailLine.vue'
import OperateStep from '@/views/score/component/scoreRecharge/operateStep.vue'
import Warn from '@/views/score/component/scoreRecharge/warn.vue'
import { onMounted, ref, watch } from 'vue'
import {
  chargeRecordsResp,
  pointsRechargeDetailModel
} from '@/model/score/score'
import { pointsRechargeDetail } from '@/api/requests/score'
import { showToast } from 'vant'
import SmallLoading from '@/components/smallLoading.vue'
import lang from '@/langs'
import { handleApiError } from '@/api/http'
const active = ref(0)
const data = ref<pointsRechargeDetailModel>()
const props = defineProps<{ id: string }>()
const icon = ref('checked')
const id = ref(props.id)
const loading = ref(false)
const info = () => [
  { name: lang('银行名称'), value: data.value?.bankName || '-' },
  { name: lang('银行账户'), value: data.value?.bankAccount || '-' },
  { name: lang('汇款人'), value: data.value?.applyName || '-' }
]
const detail = () => [
  { name: lang('申请编号'), value: data.value?.applyOrderNo || '-' },
  { name: lang('申请金额'), value: data.value?.applyAmount || '-' },
  { name: lang('汇款时间'), value: data.value?.remittanceDate || '-' },
  { name: lang('凭证'), img: data.value?.voucher || '-' }
]
const statusListFn = () => {
  let isPass
  let isSuccess
  if (data.value?.verifyStatus === 2 || data.value?.verifyStatus === 1) {
    isPass = lang('财务审核通过')
    isSuccess = lang('提交申请成功')
    icon.value = 'checked'
  } else {
    icon.value = 'clear'
    isPass = lang('财务审核不通过') + ':' + (data.value?.failReason || '--')
    isSuccess = lang('提交申请失败')
  }
  if (data.value?.verifyStatus === 1) {
    active.value = 0
  } else if (data.value?.verifyStatus === 2) {
    active.value = 2
  } else {
    active.value = 1
  }
  const list = [
    { name: lang('充值确认中'), value: data.value?.createTime || '-' },
    { name: isPass, value: data.value?.updateTime || '-' },
    { name: isSuccess, value: data.value?.verifyTime || '-' }
  ]
  return list
}
// const

const getData = () => {
  loading.value = true
  pointsRechargeDetail({ id: id.value })
    .then((value) => {
      if (value.code === 1) {
        data.value = value.data
      } else {
        showToast(
          lang(handleApiError(value.code)) ||
            value?.msg ||
            ' Service exception, please try again later'
        )
      }
    })
    .finally(() => {
      loading.value = false
    })
}
watch(
  () => props.id,
  (value) => {
    id.value = value
    if (value !== '') {
      getData()
    }
  },
  { immediate: true }
)
</script>

<style scoped lang="less">
.step3 {
  position: relative;
  height: 100%;
  :deep(.van-step__icon) {
    font-size: 15px;
  }
  :deep(.van-step__circle) {
    background: rgba(191, 191, 191, 1);
  }
  :deep(.van-hairline:after) {
    border: none;
  }
  .name {
    color: rgba(60, 60, 60, 1);
    font-size: 14px;
  }
  .time {
    color: rgba(153, 153, 153, 1);
    font-size: 12px;
  }
  .info {
    color: rgba(183, 183, 183, 1);
    font-size: 13px;
    margin: 5px 16px;
  }
}
</style>
